module.exports = __webpack_public_path__ + "img/car-dashboard-steering.571e1544.svg";